// extracted by mini-css-extract-plugin
export default {"ingredientRow":"MpLPFvuJAJIGcDC7Z4Wv"};